<template>
  <Header />
  <RouterView />
</template>

<script setup lang="ts">
import Header from '@/components/Header.vue'
</script>
